import { combineReducers } from 'redux';
import { reducer as resize } from './resizeModule';
import { reducer as resizeVolume } from './resizeVolumeModule';
import WHM from './WHM/whmReducer';
import { reducer as reboot } from './power/rebootModule';
import { reducer as reset } from './power/resetModule';
import { reducer as availableFlavors } from './availableFlavorsModule';
import { reducer as availableStorage } from './availableStorageModule';
import { reducer as vncConsole } from './vncConsoleModule';
import { reducer as availableConfigs } from './availableConfigsModule';

export default combineReducers({
	availableConfigs,
	availableFlavors,
	availableStorage,
	reboot,
	reset,
	resize,
	resizeVolume,
	vncConsole,
	WHM,
});
